<template>
  <BasicTemplate>
    <h3>
      <router-link to="/developers">Developers</router-link> /
      Developer {{ $route.params.id === 'new' ? 'new' : '#' + $route.params.id }}
    </h3>
    <DeveloperForm :item="item" @change="loadItem()" />
  </BasicTemplate>
</template>

<script>
import BasicTemplate from '../../templates/basic.vue';
import DeveloperForm from './form.vue';

export default {
  name: 'DeveloperEdit',
  components: { BasicTemplate, DeveloperForm },
  data() {
    return {
      item: null,
    };
  },
  async created() {
    this.$watch(() => this.$route.params, (newParams, prevParams) => this.loadItem());
    await this.loadItem();
  },
  methods: {
    async loadItem() {
      if (this.$route.params.id !== 'new') {
        this.item = await this.$gameApi.get('/users/' + this.$route.params.id);
      } else {
        this.item = { };
      }
    },
  }
};
</script>

